import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { BreakageReport } from "../../domain/models/breakage-report";
import {
  LoadBreakageReportFilterOptions,
  LoadBreakageReports,
} from "../../domain/usecases/load-breakage-report";
import { HttpClient } from "../protocols/http";

export class DbLoadBreakageReport implements LoadBreakageReports {
  constructor(
    private readonly url: string,
    private readonly httClient: HttpClient
  ) {}

  async load(
    warehouseId: number,
    params?: LoadBreakageReportFilterOptions
  ): Promise<BreakageReport[]> {
    const res = await this.httClient.request({
      url: this.url,
      method: "get",
      params: { warehouseId, filterOptions: params },
    });
    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      if (res.statusCode === 401 || res.statusCode === 403) {
        throw new UnauthorizedError();
      }
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
